import { IgnoredDatesForm } from '@/app/modules/home/pages/prediction/seasonal-detail/detail-holy-week/detail-holy-week.component';
import { IGetDetailHolyWeekRequest } from '../../core/interfaces/detail-seasonal.interface';

export class GetHolyWeekDetail {
  static readonly type = '[SeasonalDetail] Get Holy Week Detail';
  constructor(public payload: IGetDetailHolyWeekRequest) {}
}

export class GetRecessWeekDetail {
  static readonly type = '[SeasonalDetail] Get Recess Week Detail';
  constructor(public payload: IGetDetailHolyWeekRequest) {}
}

export class GetJuneVacationsDetail {
  static readonly type = '[SeasonalDetail] Get June Vacations Detail';
  constructor(public payload: IGetDetailHolyWeekRequest) {}
}

export class GetEndYearDetail {
  static readonly type = '[SeasonalDetail] Get End Year Detail';
  constructor(public payload: IGetDetailHolyWeekRequest) {}
}

export class SaveIgnoredDates {
  static readonly type = '[SeasonalDetail] Save Ignored Dates';
  constructor(public payload: { ignoredDates: IgnoredDatesForm | null }) {}
}
